import { Component } from '@theme/component';
import { ThemeEvents, CartAddEvent } from '@theme/events';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} popover
 * @property {HTMLElement} content
 * @extends {Component<Refs>}
 */
export class CartNotification extends Component {
  requiredRefs = ['popover', 'content'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  /** @param {CartAddEvent} event */
  #handleCartUpdate = (event) => {
    if (!(event instanceof CartAddEvent)) return;
    if (event.detail.data?.didError) return;

    // Find section rendered cart notification from form
    const source = /** @type {Element | null} */ (event.target);
    const template = /** @type {HTMLTemplateElement | null} */ (
      source?.querySelector('[ref="cartNotificationContent"]')
    );
    if (!template) return;

    this.refs.content.replaceChildren(template.content.cloneNode(true));
    this.refs.popover.showPopover();
    this.#scrollToAnchor();
  };

  /**
   * Scroll to anchor if not in view
   */
  #scrollToAnchor() {
    const target = document.querySelector(`[popovertarget="${this.refs.popover.id}"]`);

    if (target) {
      const rect = target.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (!isInView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  /** @param {boolean} [instant] */
  close(instant) {
    if (instant === true) {
      this.refs.popover.style.transitionDuration = '0s';
      setTimeout(() => (this.refs.popover.style.transitionDuration = ''));
    }
    this.refs.popover.hidePopover();
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
